



















































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
  // import {json2excel} from "js2excel";
import GlobalMixins from "@/global.mixin";
import {importExportApi} from "../../services/api/importexport.api";
import appSnackbarService from "@/services/appSnackbar.service";

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class InventoryDetailView extends Vue {

  @State("inventoryDetails") inventoryDetailsState: any;

  @Action("getProducts") getProducts: any;
  @Action("getInventoryItems") getInventoryItems: any;

  downloading = false;

  dialog = false;
  dialogDelete = false;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "inventoryItemId",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("inventoryItems-rowsPerPage") ?
                        parseInt(this.$cookies.get("inventoryItems-rowsPerPage"), 10) : 25
  };

  search = "";
  editedIndex = -1;
  defaultItem = {
    barcode: "",
    description: "",
  };
  editedItem = Object.assign({}, this.defaultItem);

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  created() {
    // this.updateData();
  }
  getHeaders() { return [
      { text: "#", value: "inventoryId", width: "1%", align: "left"},
      { text: this.$t("INVENTORY_DETAILS_TABLE_BARCODE"), value: "product.barcode", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_NAME"), value: "product.description", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_LOCATION"), value: "origLocation.name", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_LOCATION_NEW"), value: "location.name", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_READ_DT"),  value: "createdDate", sortable: true, align: "left", },
      { text: this.$t("INVENTORY_DETAILS_TABLE_USER"),  value: "user", sortable: true, align: "left", },
      { text: this.$t("TABLE_ACTIONS"), value: "actions", sortable: false },
    ];
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {
    // console.log('inventory details, updateData', this.$route.params);

    this.$cookies.set("inventoryItems-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      id: this.$route.params.inventoryId,
    };
    this.getInventoryItems(page);
  }


  back() {
    this.$router.back();
  }

  download() {
    // this.downloading = true;

    importExportApi.downloadInventoryExport({id: this.$route.params.inventoryId}, "inventory-details.xlsx");
    // .then( res => {
    //   appSnackbarService.success(err);
    // })
    // .catch( err => {
    //   appSnackbarService.error(err);
    // });
  }
}
